import React from "react";
import { useState } from "react";

export const DropdownList = (props) => {
  const [topicDisplay, setTopicDisplay] = useState("none");
  const [expand, setExpand] = useState(false);
  const toggleDisplay = (e) => {
    if (topicDisplay == "none") {
      setTopicDisplay("block");
      setExpand(true);
    } else {
      setTopicDisplay("none");
      setExpand(false);
    }
  };
  return (
    <div style={{ width: "100%", marginTop:"10px"}}>
      <button
        onClick={toggleDisplay}
        style={{
          backgroundColor: "transparent",
          color: "none",
          border: "none",
          fontWeight: "bold",
          fontSize: "12px",
          paddingLeft: "15px",
        }}
      >
        {expand && (
          <svg
            width="8"
            height="8"
            viewBox="0 0 77 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M42.8412 66.4034C40.9217 69.7623 36.0783 69.7623 34.1588 66.4034L0.772741 7.9808C-1.13209 4.64751 1.27473 0.5 5.1139 0.5H71.8861C75.7253 0.5 78.1321 4.64751 76.2273 7.98079L42.8412 66.4034Z"
              fill="white"
            />
          </svg>
        )}
        {!expand && (
          <svg
            width="8"
            height="8"
            viewBox="0 0 69 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M66.4034 34.1588C69.7623 36.0783 69.7623 40.9217 66.4034 42.8412L7.9808 76.2273C4.64751 78.1321 0.5 75.7253 0.5 71.8861V5.1139C0.5 1.27474 4.64751 -1.1321 7.98079 0.772735L66.4034 34.1588Z"
              fill="white"
            />
          </svg>
        )}
        <span style={{ marginLeft: "4px", marginTop: "6px", color:"white"}}>Topics</span>
      </button>
      <div style={{ position: "relative", display: topicDisplay }}>
        <a
        className="navbardropdown-item"
          style={{
            fontSize: 12,
            textIndent: "10px",
            paddingTop: "5px",
            textDecoration: "underline",
            textDecoration: "underline",
          }}
          rel="noopener"
          target="_blank"
          href="/nlp"
        >
          Natural Language Processing
        </a>
        <a
        className="navbardropdown-item"
          style={{
            fontSize: 12,
            textIndent: "10px",
            paddingTop: "5px",
            textDecoration: "underline",
            textDecoration: "underline",
          }}
          rel="noopener"
          target="_blank"
          href="/cv"
        >
          Computer Vision
        </a>
        <a
        className="navbardropdown-item"
          style={{
            fontSize: 12,
            textIndent: "10px",
            paddingTop: "5px",
            paddingBottom: "2px",
            textDecoration: "underline",
          }}
          rel="noopener"
          target="_blank"
          href="/story"
        >
          Others
        </a>
      </div>
    </div>
  );
};
